export default "__VITE_ASSET__aueSfFkn__"